import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
    Container,
    Box,
    Paper,
    Typography,
    TextField,
    Button,
    CircularProgress,
    Grid
} from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

const Register = () => {

    const navigate = useNavigate();
    const { register } = useAuth();

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        confirmPassword: '',
        firstName: '',
        lastName: '',
        phone: ''
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });

        if (errors[e.target.name]) {
            setErrors({
                ...errors,
                [e.target.name]: ''
            });
        }
    };

    const validateForm = () => {

        const newErrors = {};

        if (!formData.email.includes('@')) {
            newErrors.email = 'Email invalide';
        }

        if (formData.password.length < 6) {
            newErrors.password = 'Le mot de passe doit contenir au moins 6 caractères';
        }

        if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Les mots de passe ne correspondent pas';
        }

        if (!formData.firstName.trim()) {
            newErrors.firstName = 'Le prénom est requis';
        }

        if (!formData.lastName.trim()) {
            newErrors.lastName = 'Le nom est requis';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);

        try {

            const { confirmPassword, ...userData } = formData;

            await register(userData);

            toast.success('Inscription réussie ! Bienvenue !');

            navigate('/dashboard');

        } catch (err) {

            toast.error(err.message || "Erreur lors de l'inscription");

            if (err.message?.includes('email')) {
                setErrors({ email: 'Cet email est déjà utilisé' });
            }

        } finally {

            setLoading(false);

        }
    };

    return (
        <Container maxWidth="md">

            <Box sx={{ mt: 8, mb: 8 }}>

                <Paper elevation={3} sx={{ p: 4 }}>

                    <Typography
                        variant="h4"
                        align="center"
                        gutterBottom
                        sx={{ color: '#003366', fontWeight: 'bold' }}
                    >
                        Inscription
                    </Typography>

                    <Typography
                        variant="body2"
                        align="center"
                        color="text.secondary"
                        paragraph
                    >
                        Créez votre compte pour accéder à la plateforme
                    </Typography>

                    <form onSubmit={handleSubmit}>

                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Prénom"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    required
                                    error={!!errors.firstName}
                                    helperText={errors.firstName}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Nom"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    required
                                    error={!!errors.lastName}
                                    helperText={errors.lastName}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Email"
                                    name="email"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    error={!!errors.email}
                                    helperText={errors.email}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Téléphone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    placeholder="50912345678"
                                    helperText="Optionnel"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Mot de passe"
                                    name="password"
                                    type="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                    error={!!errors.password}
                                    helperText={errors.password || 'Minimum 6 caractères'}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Confirmer mot de passe"
                                    name="confirmPassword"
                                    type="password"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    required
                                    error={!!errors.confirmPassword}
                                    helperText={errors.confirmPassword}
                                />
                            </Grid>

                        </Grid>

                        <Button
                            fullWidth
                            type="submit"
                            variant="contained"
                            size="large"
                            disabled={loading}
                            sx={{
                                mt: 3,
                                mb: 2,
                                backgroundColor: '#003366',
                                '&:hover': { backgroundColor: '#004488' }
                            }}
                        >
                            {loading
                                ? <CircularProgress size={24} color="inherit" />
                                : "S'inscrire"}
                        </Button>

                        <Box sx={{ textAlign: 'center', mt: 2 }}>
                            <Typography variant="body2" color="text.secondary">
                                Vous avez déjà un compte ?{" "}
                                <Link to="/login" style={{ color: '#003366', fontWeight: 'bold' }}>
                                    Se connecter
                                </Link>
                            </Typography>
                        </Box>

                    </form>

                </Paper>

            </Box>

        </Container>
    );
};

export default Register;